import BackTop from './back-top.vue';
export default BackTop;


//////////////////
// WEBPACK FOOTER
// ./node_modules/view-design/src/components/back-top/index.js
// module id = AfYB
// module chunks = 4